// extracted by mini-css-extract-plugin
module.exports = {"container":"RightColumn-module--container--3EwP1","content":"RightColumn-module--content--jtV5T"};